import { components } from "react-select";

export const CustomOption = (props) => {
	const { data } = props;

	return (
		<components.Option {...props}>
			<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
				{data.icon && (
					<img
						src={data.icon}
						alt={data.iconAlt || ""}
						style={{
							width: data.iconWidth || "20px",
							height: "auto",
							flexShrink: 0,
						}}
						title={data.iconTitle || ""}
					/>
				)}
				<span>{props.children}</span>
			</div>
		</components.Option>
	);
};

export const CustomSingleValue = (props) => {
	const { data } = props;

	return (
		<components.SingleValue {...props}>
			<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
				{data.icon && (
					<img
						src={data.icon}
						alt={data.iconAlt || ""}
						style={{
							width: data.iconWidth || "20px",
							height: "auto",
							flexShrink: 0,
						}}
						title={data.iconTitle || ""}
					/>
				)}
				<span>{props.children}</span>
			</div>
		</components.SingleValue>
	);
};

export const CustomMultiValue = (props) => {
	const { data } = props;

	return (
		<components.MultiValue {...props}>
			<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
				{data.icon && (
					<img
						src={data.icon}
						alt={data.iconAlt || ""}
						style={{
							width: data.iconWidth || "16px",
							height: "auto",
							flexShrink: 0,
						}}
						title={data.iconTitle || ""}
					/>
				)}
				<span>{props.children}</span>
			</div>
		</components.MultiValue>
	);
};
